/**
 * Matches a cancelled fetch. Checks `name` and the message prefix rather than
 * `instanceof DOMException`, because an abort surfacing through Apollo has
 * usually been re-wrapped as a plain `Error`, losing the original `name`.
 *
 * Deliberately does not match `TimeoutError`, used by `AbortSignal.timeout` -
 * those are real failures.
 */
const isAbortError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) {
    return false;
  }

  const { name, message } = error as { name?: unknown; message?: unknown };

  return (
    name === 'AbortError' ||
    (typeof message === 'string' && message.startsWith('AbortError'))
  );
};

export { isAbortError };
